import request from '@/utils/request'


// 查询学校列表
export function listSchool(query) {
  return request({
    url: '/biz/admin/school/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询学校分页
export function pageSchool(query) {
  return request({
    url: '/biz/admin/school/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询学校详细
export function getSchool(data) {
  return request({
    url: '/biz/admin/school/detail',
    method: 'get',
    params: data
  })
}

// 新增学校
export function addSchool(data) {
  return request({
    url: '/biz/admin/school/add',
    method: 'post',
    data: data
  })
}

// 修改学校
export function updateSchool(data) {
  return request({
    url: '/biz/admin/school/edit',
    method: 'post',
    data: data
  })
}

// 删除学校
export function delSchool(data) {
  return request({
    url: '/biz/admin/school/delete',
    method: 'post',
    data: data
  })
}
